import { useQuery } from '@tanstack/react-query';
import axiosInstance from '@/dataProvider/axios';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { ORG_SERVICES_ENDPOINT } from '@/services/org-admin';
import type { OrgServiceCatalogResponse } from '@/services/org-admin';

export function useOrgServiceCatalog() {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useQuery({
    queryKey: ['org-services', orgId],
    queryFn: async () => {
      const { data } = await axiosInstance.get<OrgServiceCatalogResponse>(ORG_SERVICES_ENDPOINT(orgId!));
      return data.modules;
    },
    enabled: !!orgId,
    staleTime: 5 * 60 * 1000,
  });
}
